
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';

export default function Contact() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Contact - Cobra Sécurité | Devis Gratuit Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contactez Cobra Sécurité pour un devis gratuit. Experts en sécurité disponibles 24/7 en Tunisie. Conseil personnalisé et intervention rapide.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contact`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact Cobra Sécurité",
      "description": "Contactez-nous pour vos besoins en sécurité",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contact`,
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "Cobra Sécurité",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Avenue Habib Bourguiba",
          "addressLocality": "Tunis",
          "addressCountry": "TN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 36.8065,
          "longitude": 10.1815
        },
        "telephone": "+216-XX-XXX-XXX",
        "email": "cobra@cobrasecurite.com.tn",
        "openingHours": [
          "Mo-Fr 08:00-18:00",
          "Sa 08:00-13:00"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+216-XX-XXX-XXX",
            "contactType": "customer service",
            "availableLanguage": ["French", "Arabic"],
            "hoursAvailable": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          },
          {
            "@type": "ContactPoint",
            "telephone": "+216-XX-XXX-XXX",
            "contactType": "emergency",
            "availableLanguage": ["French", "Arabic"],
            "hoursAvailable": "24/7"
          }
        ]
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Contact Cobra Sécurité</h1>
        <ContactHero />
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <ContactForm />
          <ContactInfo />
        </div>
        <ContactMap />
      </main>
      <Footer />
    </div>
  );
}
